<template>
  <div>
    <form
      v-if="!success"
      @submit.prevent="sendForm(value)">
      <h4>{{ $t('New password') }}</h4>
      <hr>
      <div :class="{'box-loading': loading}">
        <div class="form-group">
          <label>{{ $t('Your name') }}</label>
          <input
            v-autofocus
            type="text"
            class="form-control"
            v-model="value.name">
          <ValidateMessage :error="validateErrors.name" />
        </div>
        <div class="form-group">
          <label>{{ $t('Your email') }}</label>
          <input
            type="text"
            class="form-control"
            v-model="value.email">
          <ValidateMessage :error="validateErrors.email" />
        </div>
        <div class="form-group">
          <label>{{ $t('Your password') }}</label>
          <input
            type="password"
            class="form-control"
            v-model="value.password">
          <ValidateMessage :error="validateErrors.password" />
        </div>
        <div class="form-group">
          <label>{{ $t('Confirm password') }}</label>
          <input
            type="password"
            class="form-control"
            v-model="value.password_confirmation">
          <ValidateMessage :error="validateErrors.password_confirmation" />
        </div>
        <hr>
        <div class="form-group">
          <label>{{ $t('Your timezone') }}</label>
          <select-timezone v-model="value.timezone"></select-timezone>
          <ValidateMessage :error="validateErrors.timezone" />
        </div>
        <div class="form-group">
          <label>{{ $t('Your locale') }}</label>
          <select-locale v-model="value.locale"></select-locale>
          <ValidateMessage :error="validateErrors.locale" />
        </div>
        <div>
          <button
            type="submit"
            class="btn btn-primary">{{ $t('Register') }}</button>
        </div>
      </div>
    </form>

    <div v-if="success">
      <h3 class="text-success">{{ $t('Parabens! Seu perfil foi criado com sucesso.')  }}</h3>
      <p><strong>{{ $t('Aguarde o redirecionamento...') }}</strong></p>
    </div>
    
    <hr>

    <a
      class="btn btn-block btn-outline-primary"
      :href="googleAuthUrl">
      <span class="d-flex justify-content-center align-items-center">
        <img src="https://www.svgrepo.com/show/50809/google.svg" width="20" class="mr-2">
        <span>Logar com Google</span>
      </span>
    </a>

  </div>
</template>

<script>
import SelectTimezone from '@/components/Fields/SelectTimezone'
import SelectLocale from '@/components/Fields/SelectLocale'
import config from '../../config'

export default {
  name: 'PasswordRedefined',
  components: {
    SelectTimezone,
    SelectLocale
  },
  data () {
    return {
      value: {},
      loading: true,
      success: false,
      validateErrors: {}
    }
  },
  metaInfo () {
    return {
      title: this.$t('New password')
    }
  },
  computed: {
    token () {
      return this.$route.params.token
    },
    localTimezone () {
      return Intl.DateTimeFormat().resolvedOptions().timeZone
    },
    defaultLocale () {
      const userLanguage = navigator.language || navigator.userLanguage
      const codes = config.locales.map(v => v.value)
      return codes.includes(userLanguage) ? userLanguage : codes[0]
    },
    googleAuthUrl () {
      return `${config.api_url}auth/oauth/google?callback_url=${encodeURIComponent(config.app_url + '#/auth/one-time-token')}&try_again_url=${encodeURIComponent(window.location.href)}&new_member_invite_token=${this.token}&locale=${this.defaultLocale}&timezone=${this.localTimezone}`
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    loadData () {
      this.$store
      .dispatch('authNewMemberTemplate', this.token)
      .then(response => {
        this.value = {
          ...response,
          locale: this.defaultLocale,
          timezone: this.localTimezone
        }
      })
      .finally(() => {
        this.loading = false
      })
    },
    sendForm (value) {
      this.loading = true

      this.$store
      .dispatch('authNewMember', {
        token: this.token,
        ...value
      })
      .then(response => {
        this.success = true
        setTimeout(() => {
          this.$store.dispatch('authSetToken', response.token)
          this.$router.push('/')
        }, 4000)
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
      .finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Auth/NewMember.vue